import { render, staticRenderFns } from "./EditToolbar.vue?vue&type=template&id=f2bc202c&scoped=true"
import script from "./EditToolbar.vue?vue&type=script&lang=js"
export * from "./EditToolbar.vue?vue&type=script&lang=js"
import style0 from "./EditToolbar.vue?vue&type=style&index=0&id=f2bc202c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bc202c",
  null
  
)

export default component.exports